import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import GlobalBanner from 'components/pages/GlobalBanner'

import { selectData } from '../App/selectors'

import { selectMailboxesSyncing, selectShowDemoBanner } from './selectors'

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)
const mapStateToProps = (state) => ({
  data: selectData(state),
  showDemoBanner: selectShowDemoBanner(state),
  mailboxesSyncing: selectMailboxesSyncing(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(GlobalBanner)

export default withRouter(render)
